
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectRoofTypesEnum } from '../models/work-project-roof-types-enum';
import { WorkProjectRealEstateTypePositionEnum } from '../models/work-project-real-estate-type-position-enum';

export function getUpdateProjectDtoFormGroup() {
return new FormGroup({
    containerId: new FormControl<number | undefined>(undefined),
    teamId: new FormControl<number | undefined>(undefined),
    supplierId: new FormControl<number | undefined>(undefined),
    authenticatorId: new FormControl<number | undefined>(undefined),
    statusId: new FormControl<number | undefined>(undefined),
    reasontypeId: new FormControl<number | undefined>(undefined),
    salesworkflowId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    tpbUserId: new FormControl<number | undefined>(undefined),
    electricianUserId: new FormControl<number | undefined>(undefined),
    realestatetypeId: new FormControl<number | undefined>(undefined),
    number: new FormControl<number | undefined>(undefined),
    numberQualified: new FormControl<string | undefined>(undefined, [Validators.maxLength(45)]),
    title: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    revenueChf: new FormControl<number | undefined>(undefined),
    revenueChfCalculated: new FormControl<number | undefined>(undefined),
    powerKwp: new FormControl<number | undefined>(undefined),
    area: new FormControl<number | undefined>(undefined),
    purchaseChfKwp: new FormControl<number | undefined>(undefined),
    sellingChfKwp: new FormControl<number | undefined>(undefined),
    revenueKwhYear: new FormControl<number | undefined>(undefined),
    revenueKwhSpecific: new FormControl<number | undefined>(undefined),
    moduleOrientation: new FormControl<string | undefined>(undefined, [Validators.maxLength(255)]),
    priceOffered: new FormControl<number | undefined>(undefined),
    lot: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    tobNotes: new FormControl<string | undefined>(undefined),
    start: new FormControl<string | undefined>(undefined),
    end: new FormControl<string | undefined>(undefined),
    planned: new FormControl<string | undefined>(undefined),
    sale: new FormControl<string | undefined>(undefined),
    build: new FormControl<string | undefined>(undefined),
    installationStart: new FormControl<string | undefined>(undefined),
    installationEnd: new FormControl<string | undefined>(undefined),
    installationStartFixed: new FormControl<boolean | undefined>(undefined),
    creditorsClosed: new FormControl<boolean | undefined>(undefined),
    implementing: new FormControl<string | undefined>(undefined),
    supply: new FormControl<string | undefined>(undefined),
    buildingpermit: new FormControl<boolean | undefined>(undefined),
    hasEqualObjectAddress: new FormControl<boolean | undefined>(undefined),
    esti: new FormControl<boolean | undefined>(undefined),
    constructionType: new FormControl<string | undefined>(undefined),
    systemType: new FormControl<string | undefined>(undefined),
    communicationLevel: new FormControl<number | undefined>(undefined),
    kevNumber: new FormControl<string | undefined>(undefined, [Validators.maxLength(45)]),
    kevRegistration: new FormControl<string | undefined>(undefined),
    kevCertification: new FormControl<string | undefined>(undefined),
    kevIbnComplete: new FormControl<boolean | undefined>(undefined),
    kevStatus: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    eivFinancing: new FormControl<boolean | undefined>(undefined),
    eivFinancingAmount: new FormControl<number | undefined>(undefined),
    communitySponsorshipAmount: new FormControl<number | undefined>(undefined),
    tmpSerialnumbers: new FormControl<string | undefined>(undefined),
    partialpayment1: new FormControl<number | undefined>(undefined),
    partialpayment2: new FormControl<number | undefined>(undefined),
    partialpayment3: new FormControl<number | undefined>(undefined),
    partialpayment4: new FormControl<number | undefined>(undefined),
    tax: new FormControl<number | undefined>(undefined),
    salesinformation: new FormControl<string | undefined>(undefined),
    offerBasedOnDescription: new FormControl<string | undefined>(undefined),
    objectStreet: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    objectZip: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    objectCity: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    objectCanton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    longitude: new FormControl<number | undefined>(undefined),
    latitude: new FormControl<number | undefined>(undefined),
    locked: new FormControl<boolean | undefined>(undefined),
    lockedNotes: new FormControl<string | undefined>(undefined),
    specialReference: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    appImage: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    discountChfIncl: new FormControl<number | undefined>(undefined),
    discountChfExcl: new FormControl<number | undefined>(undefined),
    skontoPercentage: new FormControl<number | undefined>(undefined),
    skontoDays: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    migContactCrmId: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    externalProjectManagerContactId: new FormControl<number | undefined>(undefined),
    clientContactId: new FormControl<number | undefined>(undefined),
    roofType: new FormControl<WorkProjectRoofTypesEnum | undefined>(undefined),
    realestateTypePosition: new FormControl<WorkProjectRealEstateTypePositionEnum | undefined>(undefined),
})
;
}
      